import {STATUS_CODES} from 'core/constants';
import {Layout} from 'layouts/BasicLayout';
import NotFoundPage from 'modules/errors/pages/NotFoundPage';
import {FC, ReactNode} from 'react';

interface IErrorLayout {
    children: ReactNode;
    errorStatusCode?: number;
}

export const ErrorLayout: FC<IErrorLayout> = ({children, errorStatusCode}) => {
    if (STATUS_CODES.NOT_FOUND === errorStatusCode) {
        return (
            <Layout>
                <NotFoundPage />
            </Layout>
        );
    }

    return <>{children}</>;
};
